import styled from "styled-components";

export const MessageContainer = styled.div`
  padding: 10rem 30rem 20rem 30rem;
  h1 {
    ${({ theme }) => `
      color: ${theme.colors.blackTextTitle};
    `}
    font-size: 3rem;
    font-style: normal;
    font-weight: 800;
    line-height: 3.7rem;
    text-align: center;
  }
  h3 {
    ${({ theme }) => `
      color: ${theme.colors.blackTextBody};
    `}
    font-size: 1.8rem;
    font-style: normal;
    font-weight: 600;
    line-height: 2.2rem;
    text-align: center;
  }
  .gray {
    margin-top: 3.6rem;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 3.2rem;
`;

interface IMainButton {
  isLoading?: any;
}
export const MainButton = styled.button<IMainButton>`
  ${(props) => `
    background-color: ${props.theme.colors.accentGreen};
    cursor: ${props.isLoading ? "default" : "pointer"};
    font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  color: ${(props) => props.theme.colors.white};
  align-items: center;
  border: none;
  border-radius: 8px;
  display: flex;
  font-size: 1.7rem;
  font-weight: 700;
  height: 6.4rem;
  justify-content: center;
  width: 34.8rem;

  &:disabled,
  &[disabled] {
    background-color: ${({ theme }) =>
      theme.colors.accentGreen + theme.transparencies.p20};
    cursor: default;
  }

  img {
    height: 5rem;
    width: 5rem;
  }
`;

export const GrayText = styled.p`
  ${(props) => `
    color: ${props.theme.colors.gray};
  `}
  font-size: 1.4rem;
  font-weight: 500;
  font-weight: 500;
  justify-self: center;
  margin: 0 0 0.6rem 0;
`;
